import { NavLink, Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import { Anchor, Menu, X } from "lucide-react";

const NAV = [
  { to: "/", label: "Home", end: true },
  { to: "/about", label: "About" },
  { to: "/experiences", label: "Experiences" },
  { to: "/events", label: "Events" },
  { to: "/captains-club", label: "Club" },
  { to: "/menu", label: "Menu" },
  { to: "/gallery", label: "Gallery" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header
      className="nav-glass sticky top-0 z-50"
      data-testid="main-nav"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 h-20 flex items-center justify-between">
        <Link
          to="/"
          className="flex items-center gap-2 text-navy"
          data-testid="nav-logo"
        >
          <Anchor size={22} strokeWidth={1.5} />
          <span className="font-serif-display text-2xl leading-none">
            Anchor Management
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-9">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.end}
              data-testid={`nav-link-${item.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-[0.78rem] tracking-[0.22em] uppercase font-medium transition-colors ${
                  isActive
                    ? "text-navy"
                    : "text-[color:var(--am-muted)] hover:text-navy"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
          <Link
            to="/book"
            className="btn-primary text-[0.72rem] py-3 px-5"
            data-testid="nav-book-now-button"
          >
            Book Now
          </Link>
        </nav>

        <button
          className="lg:hidden text-navy"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
          data-testid="mobile-menu-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          className="lg:hidden border-t border-[color:var(--am-line)] bg-white"
          data-testid="mobile-menu"
        >
          <nav className="flex flex-col px-6 py-6 gap-5">
            {NAV.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.end}
                data-testid={`mobile-nav-link-${item.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-sm tracking-[0.22em] uppercase font-medium ${
                    isActive ? "text-navy" : "text-[color:var(--am-muted)]"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            <Link
              to="/book"
              className="btn-primary text-xs py-3 w-fit"
              data-testid="mobile-book-now-button"
            >
              Book Now
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
}
